<template>
  <div class="w-100">
    <div
      class="flex justify-between items-center h-14 min-h-[3.5rem] px-4 py-2 bg-white dark:bg-slate-900 border-b border-slate-50 dark:border-slate-800/50"
    >
      <div class="flex w-100">
        <div class="flex pipeline w-[30%]">
          <!-- <div class="back-icon" @click="backUrl">
            <fluent-icon
              v-tooltip="'Back'"
              icon="back"
              :viewBox="'0 0 52 52'"
              size="14"
              class="mt-0.5 grey-color"
            />
          </div> -->
          <div class="pipeline-heading" >
            <span
              :title="boardTitle.length > 20 ? boardTitle : ''"
            >
              {{ truncatedBoardTitle }}
            </span>
          </div>
        </div>
        <div class="searching-filter w-[70%]">
          <div class="flex filter-box">
            <div
            v-if="hasActiveBoardFilter && activeBoardFilterName"
            class="saved-filter-chip"
            :title="activeBoardFilterName.length > 25 ? activeBoardFilterName : ''"
          >
            <span class="saved-filter-chip-text">
              {{ activeBoardFilterName }}
            </span>
            <button
              type="button"
              class="saved-filter-chip-close"
              @click="clearActiveSavedBoardFilter"
            >
              <fluent-icon icon="dismiss" size="12" />
            </button>
          </div>
            <!-- <div class="state-input filter-text">
              <select
                @change="handleDropdownBoard"
                v-model="selectedBoard"
                class="pipeline-dropdown new-color"
              >
                <option value="">{{ $t('PIPELINES.BOARD') }}</option>
                <option
                  v-for="board in boards"
                  :key="board.name"
                  :value="board.id"
                >
                  {{ board.name }}
                </option>
                <option value="add-more-board" class="add-more-option">
                  {{ $t('PIPELINES.ADD_MORE_BOARD') }}
                </option>
              </select>
              <add-more-board :show="showMoreBoard" @close="hideMoreboard" />
            </div> -->

             <!-- Filter Buttons -->
            <div class="flex items-center gap-2">
              <woot-button
                v-if="hasAppliedFilters && !hasActiveBoardFilter"
                v-tooltip.top-end="$t('FILTER.CUSTOM_VIEWS.ADD.SAVE_BUTTON')"
                size="medium"
                variant="smooth"
                color-scheme="secondary"
                icon="save"
                @click="onClickOpenAddBoardFiltersModal"
              >
                Save Filter
              </woot-button>
              <woot-button
                v-if="hasAppliedFilters && !hasActiveBoardFilter"
                v-tooltip.top-end="$t('FILTER.CLEAR_BUTTON_LABEL')"
                size="medium"
                variant="smooth"
                color-scheme="alert"
                icon="dismiss-circle"
                @click="clearFilters"
              />
              <woot-button
                v-if="hasActiveBoardFilter"
                v-tooltip.top-end="$t('BOARD_FILTER.EDIT_CUSTOM_FILTER')"
                size="medium"
                variant="smooth"
                color-scheme="secondary"
                icon="edit"
                @click="onToggleAdvanceFiltersModal"
              />
              <woot-button
                v-if="hasActiveBoardFilter"
                v-tooltip.top-end="$t('FILTER.CUSTOM_VIEWS.DELETE.DELETE_BUTTON')"
                size="medium"
                variant="smooth"
                color-scheme="alert"
                icon="delete"
                @click="onClickOpenDeleteBoardFiltersModal"
              />
              <div
                v-if="!hasActiveBoardFilter"
                class="relative inline-flex"
              >
                <woot-button
                  v-tooltip.top-end="$t('BOARD_FILTER.TOOLTIP_LABEL')"
                  size="medium"
                  variant="smooth"
                  color-scheme="secondary"
                  icon="filter"
                  @click="onToggleAdvanceFiltersModal"
                />
                <span
                  v-if="hasAppliedFilters"
                  class="absolute w-2 h-2 rounded-full top-1 right-3 bg-slate-500 dark:bg-slate-500"
                />
              </div>
              <last-activity
                v-if="hasCurrentBoardSavedFilters"
                :key="boardFilterDropdownKey"
                class="board-filter-top-dropdown"
                :states="boardFilterDropdownItems"
                :placeholder="boardFilterDropdownPlaceholder"
                :truncate-length="10"
                :open="openDropdown === 'boardfilters'"
                @input="handleBoardFilterDropdown"
                @toggle="toggleDropdown('boardfilters')"
              />
            </div>
        <div v-if="((isAdmin||currentUser.role==='agent') && isAgentAutoAssigneToBothFeatureEnabled)">
          <div 
            class="reminder-icon-wrapper cursor-pointer"
            @click="openReminderModal"
            :title="'View Reminders'"
          >
            <div class="icon-with-badge">
              <fluent-icon 
                icon="clock" 
                size="20" 
                viewBox="0 0 15 15"
                class="reminder-icon"
              />
              
              <div class="dual-badge">
                <span 
                  class="notification-badge green-badge"
                  v-if="reminderCount > 0"
                >
                  {{ reminderCount }}
                </span>
                <span 
                  class="notification-badge red-badge"
                  v-if="pastReminderCount > 0"
                >
                  {{ pastReminderCount }}
                </span>
              </div>

            </div>
          </div>
        </div>


            <!-- <div>
              <CustomDropdown
                :boards="boards"
                placeholder="Board"
                addMoreLabel="Add More Board"
                :open="openDropdown === 'board'"
                @input="handleDropdownBoard"
                @addMore="handleDropdownBoard"
                @toggle="toggleDropdown('board')"
              />
              <add-more-board :show="showMoreBoard" @close="hideMoreboard" />
            </div> -->


            <!-- <div>
              <LastPipeline
                :states="statusData"
                placeholder="Last Pipeline"
                :open="openDropdown === 'lastpipeline'"
                @input="handleDropdownPipeline"
                @toggle="toggleDropdown('lastpipeline')"
              />
            </div> -->
<!-- 
            <div v-if="!hasActiveBoardFilter"> -->
              <!-- <p>Selected Date Range: {{ customDate }}</p> -->

            <div
              class="flex items-center relative mr-2 search-wrap input-search"
            >
              <input
                type="text"
                :placeholder="'Search Lead by Name, Phone, Email Id'"
                class="contact-search border-slate-100 dark:border-slate-600"
                v-model.trim="searchQuery"
                @keyup.enter="filterbyinput"
              />
              <div class="search-icon-data">
                <fluent-icon
                  icon="search"
                  class="dark:bg-slate-900 dark:text-slate-200 h-5 leading-9 text-slate-700 text-sm"
                />
              </div>
              <!-- <woot-button
                :is-loading="false"
                class="clear"
                :class-names="searchButtonClass"
                @click="filterbyinput"
              >
                {{ $t('CONTACTS_PAGE.SEARCH_BUTTON') }}
              </woot-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="h-full">
      <div ref="pipelineContainer" class="pipeline-container">
        <new-pipeline
          ref="newPipeline"
          @contact-count-updated="updateLeadCount"
          :currentassignee="currentAssignee"
        />
      </div>
      <scroll-minimap
        :container="pipelineScrollContainer"
        item-selector=".pipeline-main"
      />
    </div>
    <footer class="w-full bg-white  p-2  fixed bottom-0 left-0 border-t border-[rgb(236,238,240)] text-[rgb(60,72,88)] flex items-center px-4">
      <div class="mx-[3.7rem] flex-1 text-left text-[12px]">Total Lead: <span  class="font-bold">{{ totalLeadCount }}</span> </div>
    </footer>
    
    <!-- Board Filters Modal -->
    <woot-modal
      :show.sync="showAdvancedFilters"
      :on-close="closeAdvanceFiltersModal"
      size="medium"
    >
      <board-advanced-filters
        v-if="showAdvancedFilters"
        :on-close="closeAdvanceFiltersModal"
        :initial-filter-types="boardFilterTypesTranslated"
        :initial-applied-filters="appliedFilter"
        :current-board-id="currentBoardId"
        :active-board-filter-name="activeBoardFilterName"
        :is-board-filter-view="hasActiveBoardFilter"
        @applyFilter="onApplyFilter"
        @updateBoardFilter="onUpdateBoardFilter"
        @clearFilters="clearFilters"
      />
    </woot-modal>

    <!-- Save Board Filter Modal -->
    <add-custom-views
      v-if="showAddBoardFiltersModal"
      :custom-views-query="boardFiltersQuery"
      :filter-type="3"
      :open-last-saved-item="openLastSavedItemInBoardFilter"
      @close="onCloseAddBoardFiltersModal"
    />

    <!-- Delete Board Filter Modal -->
    <delete-custom-views
      v-if="showDeleteBoardFiltersModal"
      :show-delete-popup.sync="showDeleteBoardFiltersModal"
      :active-custom-view="activeBoardFilter"
      :custom-views-id="boardFilterId"
      :active-filter-type="3"
      :open-last-item-after-delete="openLastItemAfterDeleteInBoardFilter"
      @close="onCloseDeleteBoardFiltersModal"
    />

    <!-- Reminder Modal -->
    <ReminderModal
      :show="showReminderModal"
      @close="closeReminderModal"
      @refresh-board="refreshBoardAfterReminder"
    />
  </div>
</template>

<script>
import AddCustomDate from './AddCustomDate.vue';
import AssigneeList from './AssigneeList.vue';
import AddMoreState from './AddMoreState.vue';
import NewPipeline from './NewPipeline.vue';
import { mapGetters } from 'vuex';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import AddMoreBoard from './AddMoreBoards.vue';
import Thumbnail from '../../../../components/widgets/Thumbnail.vue';
import { mixin as clickaway } from 'vue-clickaway';
import CustomDropdown from './CustomDropdown.vue';
import SelectState from './StateDropdown.vue';
import DateDropdown from './DateDropdown.vue';
import SourceLeadDropdown from './SourceLeadDropdown.vue';
import AssigneeImage from './indexSearching/AssigneeImage.vue';
import alertMixin from 'shared/mixins/alertMixin';
import LastActivity from './LastActivity.vue';
import ReminderModal from './ReminderModal.vue';
import isAdminMixin from 'dashboard/mixins/isAdmin';
import LastPipeline from './LastPipeline.vue';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import BoardAdvancedFilters from './BoardAdvancedFilters.vue';
import AddCustomViews from 'dashboard/routes/dashboard/customviews/AddCustomViews';
import DeleteCustomViews from 'dashboard/routes/dashboard/customviews/DeleteCustomViews';
import boardFilterTypes, { boardFilterItems } from './boardFilterItems';
import filterQueryGenerator from '../../../../helper/filterQueryGenerator.js';
import { generateValuesForEditCustomViews } from 'dashboard/helper/customViewsHelper';
import ScrollMinimap from 'dashboard/components/ui/ScrollMinimap.vue';

export default {
  components: {
    AddCustomDate,
    AssigneeList,
    NewPipeline,
    AddMoreState,
    LoadingState,
    AddMoreBoard,
    Thumbnail,
    CustomDropdown,
    SelectState,
    DateDropdown,
    SourceLeadDropdown,
    AssigneeImage,
    LastActivity,
    ReminderModal,
    LastPipeline,
    BoardAdvancedFilters,
    AddCustomViews,
    DeleteCustomViews,
    ScrollMinimap,
  },
  props: {
    board_id: {
      type: [String, Number],
      default: null,
    },
    boardFilterId: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      showCustomDateModal: true, // Controls the modal visibility
      customDate: '', // Holds the selected custom date range
      scheduledAtFrom: null,
      scheduledAtTo: null,
      openDropdown: null,
      selectedState: '',
      lastActivity: '',
      selectedSource: '',
      searchQuery: '',
      selectedRange: '',
      showCustomDate: false,
      enabled: false,
      showMoreState: false,
      selectedBoard: '',
      showMoreBoard: false,
      // Board filter properties
      showAdvancedFilters: false,
      showAddBoardFiltersModal: false,
      showDeleteBoardFiltersModal: false,
      appliedFilter: [],
      boardFiltersQuery: {},
      boardFilterTypesTranslated: boardFilterTypes.map(filter => ({
        ...filter,
        attributeName: this.$t(
          `BOARD_FILTER.ATTRIBUTES.${filter.attributeI18nKey}`
        ),
      })),
      src: 'data:image/jpeg;base64,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',
      showAssignee: false,
      currentAssignee: null,
      filterMonths: '',
      currentAssigneedata: {},
      dateOptions: [
        {
          id: '',
          name: this.$t('PIPELINES.ALL'),
          value: 'all',
        },
        {
          id: 1,
          name: this.$t('PIPELINES.Last_Week'),
          value: 'last week',
        },
        {
          id: 2,
          name: this.$t('PIPELINES.Last_Month'),
          value: 'last month',
        },
        {
          id: 3,
          name: this.$t('PIPELINES.Last_6_Month'),
          value: 'last six months',
        },
        {
          id: 4,
          name: this.$t('PIPELINES.CUSTOM_DATE'),
          value: 'custom',
        },
      ],
      totalLeadCount: 0,
      showReminderModal: false,
      pipelineScrollContainer: null,
    };
  },
  mixins: [alertMixin, clickaway, isAdminMixin],
  watch: {
    searchQuery(newVal) {
      if (newVal.length == 0) {
        if (this.hasActiveBoardFilter) {
          this.applySearchInSavedBoardFilter('');
          return;
        }
        let data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
          key8: 'prev_status_id',
        value8: this.previousPipeline,
        };

        if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
        // Normalize filterMonths value (e.g., replacing spaces with underscores)
        const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

        if (normalizedFilter) {
          switch (normalizedFilter) {
            case 'all':
              data.key2 = 'all';
              data.value2 = this.filterMonths;
              break;
            case 'last_week':
              data.key2 = 'last_week';
              data.value2 = this.filterMonths;
              break;
            case 'last_month':
              data.key2 = 'last_month';
              data.value2 = this.filterMonths;
              break;
            case 'last_six_months':
              data.key2 = 'last_six_months';
              data.value2 = this.filterMonths;
              break;
            default:
              console.warn('Unknown filterMonths value:', this.filterMonths);
              break;
          }
        } else {
          data.key2 = 'start_date';
          data.value2 = this.scheduledAtFrom; // The start date filter
          data.key3 = 'end_date';
          data.value3 = this.scheduledAtTo; // The end date filter
        }
        this.$store.dispatch('pipelines/FilterContact', data);
      }
    },
    selectedBoard(newBoard) {
      if (newBoard && typeof newBoard === 'number') {
        this.$router.replace({
          name: 'pipeline_boards',
          params: { board_id: newBoard },
        });
      }
    },
    board_id(newBoardId) {
      if (newBoardId) {
        this.selectedBoard = newBoardId;
      }
    },
    '$route'(to, from) {
      // Skip if this is the initial route (no 'from' route)
      if (!from.name) {
        return;
      }
      
      // Entering/switching saved board filter view
      if (to.name === 'pipeline_custom_view') {
        const idChanged = to.params.id !== from.params.id;
        const boardChanged = to.params.board_id !== from.params.board_id;
        if (!idChanged && !boardChanged) {
          return;
        }

        this.selectedBoard =
          this.board_id || to.params.board_id || this.selectedBoard;

        // Only fetch if switching between filters (not initial load)
        this.$store.dispatch('pipelines/prepareBoardFetch');
        this.$store.dispatch('customViews/get', 'board').then(() => {
          if (this.activeBoardFilter?.query) {
            this.fetchFilteredContacts(this.activeBoardFilter.query);
          }
        });
        return;
      }

      // Leaving saved filter view back to normal board view (same board id included)
      if (from.name === 'pipeline_custom_view' && to.name === 'pipeline_boards') {
        this.selectedBoard = to.params.board_id || this.board_id || this.selectedBoard;
        const boardId = this.selectedBoard || this.$route.params.board_id;
        this.$store.dispatch('pipelines/prepareBoardFetch');
        
        // When leaving a saved filter view, always check for manually applied filters
        // If no manual filters exist, load full board data
        this.$nextTick(() => {
          const savedFilters = this.getAppliedBoardFiltersByBoard(boardId);
          if (savedFilters && savedFilters.length > 0) {
            // User had manually applied filters before saving, restore those
            this.syncBoardScopedFilters(boardId);
          } else {
            // No manual filters, load full board data
            this.$store.dispatch('pipelines/getStatus', {
              board_id: boardId,
            });
          }
        });
      }
    },
    '$route.params.board_id'(newBoardId, oldBoardId) {
      if (newBoardId !== oldBoardId) {
         this.$store.dispatch('pipelines/prepareBoardFetch');
         this.selectedBoard = newBoardId || this.board_id;
         this.syncBoardScopedFilters(newBoardId || this.selectedBoard);
         document.title = `${this.boardName()} | Kivo`; // ✅ Update title here
      }
},
  // Also watch for boards data to be loaded
  boards: {
    handler() {
      document.title = `${this.boardName()} | Kivo`;
    },
    immediate: true
  },
  },
  mounted() {
    const boardId = this.board_id || this.$route.params.board_id;
    this.selectedBoard = boardId
    this.$store.dispatch('pipelines/prepareBoardFetch');
    this.$store.dispatch('pipelines/getState');
    this.$store.dispatch('pipelines/getBoards');
    this.$store.dispatch('pipelines/getAssignee');
    this.$store.dispatch('pipelines/fetchReminders', this.accountId)
    // Fetch custom views for boards and load correct dataset based on route
    this.$store.dispatch('customViews/get', 'board').then(() => {
      if (this.hasActiveBoardFilter) {
        this.fetchFilteredContacts(this.activeBoardFilter?.query || []);
      } else {
        this.syncBoardScopedFilters(
          this.selectedBoard || this.board_id || this.$route.params.board_id
        );
      }
    });
    this.$root.$on('contact-count-updated', this.updateLeadCount);
    bus.$on('toggle-pipeline-dropdown-dragging', this.closeAlldraggable);
    bus.$on('dropdown-data', this.setSearchNull);
    bus.$on('dropdown-data', this.setDropdownNull);
    bus.$on('reset-date-dropdown', () => {
      this.customDate = ''; // Reset custom date
    });
    console.log('My Inboxes', this.inboxes);
    document.title = `${this.boardName()} | Kivo`;
    this.updateLeadCount();
    this.setPipelineScrollContainer();
  },
  beforeDestroy() {
    this.pipelineScrollContainer = null;
    this.$root.$off('contact-count-updated', this.updateLeadCount);
    bus.$off('reset-date-dropdown'); // Cleanup event listener
  },
  computed: {
    ...mapGetters({
      uiFlags: 'pipelines/getUIFlags',
      inboxes: 'inboxes/getInboxes',
      labels: 'labels/getLabels',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      currentUser: 'getCurrentUser',
      reminderCounts: 'pipelines/getReminderCount',
      getAppliedBoardFiltersByBoard: 'pipelines/getAppliedBoardFiltersByBoard',
      boardFilters: 'customViews/getCustomViews',
    }),
    hasAppliedFilters() {
      return this.currentBoardAppliedFilters.length !== 0;
    },
    hasActiveBoardFilter() {
      return this.activeBoardFilter && this.boardFilterId !== 0;
    },
    currentBoardId() {
      const boardId = this.selectedBoard || this.board_id || this.$route.params.board_id;
      return boardId ? Number(boardId) : null;
    },
    currentBoardAppliedFilters() {
      if (!this.currentBoardId || !this.getAppliedBoardFiltersByBoard) return [];
      return this.getAppliedBoardFiltersByBoard(this.currentBoardId) || [];
    },
    currentBoardSavedFilters() {
      if (!this.currentBoardId) return [];
      return (this.boardFilters || []).filter(view => {
        if (view.filter_type !== 'board') return false;
        const viewBoardId = Number(view?.query?.board_id);
        return !Number.isNaN(viewBoardId) && viewBoardId === this.currentBoardId;
      });
    },
    hasCurrentBoardSavedFilters() {
      return this.currentBoardSavedFilters.length > 0;
    },
    boardFilterDropdownItems() {
      return [{ id: '', name: 'All' }, ...this.currentBoardSavedFilters];
    },
    boardFilterDropdownPlaceholder() {
      return this.hasActiveBoardFilter && this.activeBoardFilterName
        ? this.activeBoardFilterName
        : 'Board Filter';
    },
    boardFilterDropdownKey() {
      return `board-filter-${this.currentBoardId || 'none'}-${this.boardFilterId || 'all'}-${this.$route.name}`;
    },
    activeBoardFilter() {
      if (this.boardFilterId) {
        const activeView = this.boardFilters.filter(
          view => view.id === Number(this.boardFilterId) && view.filter_type === 'board'
        );
        const [firstValue] = activeView;
        return firstValue;
      }
      return undefined;
    },
    activeBoardFilterName() {
      return this.activeBoardFilter?.name;
    },
    boardTitle() {
      return this.boardName();
    },
    truncatedBoardTitle() {
      return this.boardTitle.length >20
        ? `${this.boardTitle.slice(0, 20)}...`
        : this.boardTitle;
    },
    states() {
      // return this.$store.getters['pipelines/getAllStatus'];
      return [
        { id: '', name: 'All' },
        ...this.$store.getters['pipelines/getAllStatus'],
      ];
    },
    statusData() {
      this.list = this.$store.getters['pipelines/getAllState'].length;
      return this.$store.getters['pipelines/getAllState'];
    },
    lastactivity() {
  return [
    { id: 1, name: 'All' },
    { id: 2, name: 'Last Activity User' },
    { id: 3, name: 'Last Activity Agent' },
  ];
},
    inboxesWithAll() {
      return [{ id: '', name: 'All' }, ...this.inboxes];
    },
    boards() {
      const apiBoards = this.$store.getters['pipelines/getAllBoards'] || [];

      // Filter out any board named "Default Board" with an id
      const filteredBoards = apiBoards.filter(
        board => !(board.name === 'Default Board' && board.id)
      );

      // Add your intended default board manually (id: '')
      return [{ id: '', name: 'Default Board' }, ...filteredBoards];
    },
    searchButtonClass() {
      return this.searchQuery !== '' ? 'show' : '';
    },
    assigneedata() {
      return [
        { id: '', name: 'Deselect' },
        ...this.$store.getters['pipelines/getAllAssignee'],
      ];
    },
     isAgentAutoAssigneToBothFeatureEnabled() {
      const isAutoAssigne= this.isFeatureEnabledonAccount(this.accountId, FEATURE_FLAGS.REMINDER_ALL_DATA);
      return isAutoAssigne
    },
    isAgentBotsFeatureEnabledReminder() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.FILTER_BOARD
      );
    },
      reminderCounts() {
        return this.$store.getters['pipelines/getReminderCount'];
      },
      reminderCount() {
        return this.reminderCounts.upcoming;
      },
      pastReminderCount() {
        return this.reminderCounts.past;
      }
  },
  methods: {
    onCustomDateSelected({ scheduledAtFrom, scheduledAtTo }) {
      // this.customDate = dateRange; // Update the custom date range
      // this.showCustomDateModal = false; // Close modal
      const formattedFrom = this.formatDate(scheduledAtFrom);
      const formattedTo = this.formatDate(scheduledAtTo);
      // Prepare the data object with the formatted dates and filters
      const data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key2: 'start_date',
        value2: this.scheduledAtFrom, // The formatted start date
        key3: 'end_date',
        value3: this.scheduledAtTo, // The formatted end date
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
        key8: 'prev_status_id',
        value8: this.previousPipeline,
      };
      if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }

      console.log('Date with filters:', data); // Log the final data object

      // Dispatch the store action with the prepared data
      this.$store.dispatch('pipelines/FilterContact', data);
      // Format the string for display
      this.customDate = `${formattedFrom} to ${formattedTo}`;
      console.log('Updated Custom Date:', this.customDate); // Debugging
    },
    setSearchNull() {
      this.searchQuery = '';
    },
    handleDropdownChange(selectedId) {
      this.selectedState = selectedId;
      console.log('Selected State:', this.selectedState);
      if (this.selectedState == 'add-more') {
        this.showMoreState = true;
      } else if (this.selectedState != 'add-more') {
        this.callApi(this.selectedState);
      }
    },

    handleDropdownActivity(selectedId) {
      this.lastActivity = selectedId;
      console.log('Selected State:', this.lastActivity);
      if (this.lastActivity != 'add-more') {
        this.callApiActivity(this.lastActivity);
      }
    },

    handleDropdownPipeline(selectedId) {
      this.lastActivity = selectedId;
      console.log('Selected State:', this.lastActivity);
      if (this.lastActivity != 'add-more') {
        this.callApiPipeline(this.lastActivity);
      }
    },

    handleDropdownLead(selectedId) {
      this.selectedSource = selectedId;
      console.log('Selected State:', this.selectedSource);
      this.callApiLead(this.selectedSource);
    },

    // handleDropdownBoard(selectedId) {
    //   this.selectedBoard = selectedId;
    //   console.log('Selected Boards:', this.selectedBoard);
    //   // this.$store.dispatch('pipelines/getBoards');
    //   if (this.selectedBoard == 'add-more-board') {
    //     this.showMoreBoard = true;
    //   } else if (this.selectedBoard != 'add-more') {
    //     this.callApiboard(this.selectedBoard);
    //   }
    // },
    handleDropdownBoard(selectedId) {
      this.selectedBoard = selectedId;
      console.log('Selected Boards:', this.selectedBoard);

      if (this.selectedBoard === 'add-more-board') {
        this.showMoreBoard = true;
      } else if (this.selectedBoard === '') {
        // "All" selected — navigate to default pipeline route
        if (this.$route.name !== 'pipeline') {
          this.$router.push({ name: 'pipeline' });
        }
        this.callApiboard(this.selectedBoard);
      } else if (this.selectedBoard !== 'add-more') {
        this.callApiboard(this.selectedBoard);
      }
    },

    callApi(selectedState) {
      console.log(`Making API call with state: ${selectedState}`);
      this.selectedState = selectedState;
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
        key8: 'prev_status_id',
        value8: this.previousPipeline,
      };

      if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'all':
            data.key2 = 'all';
            data.value2 = this.filterMonths;
            break;
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    callApiActivity(selectedActivity) {
      console.log(`Making API call with state: ${selectedActivity}`);
      this.lastActivity = selectedActivity;
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
        key8: 'prev_status_id',
        value8: this.previousPipeline,
      };
      console.log('Data before lastActivity:', this.lastActivity);
      if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'all':
            data.key2 = 'all';
            data.value2 = this.filterMonths;
            break;
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    callApiPipeline(selectedActivity) {
      console.log(`Making API call with state: ${selectedActivity}`);
      this.previousPipeline = selectedActivity;
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
        key8: 'prev_status_id',
        value8: this.previousPipeline,
      };
      console.log('Data before lastActivity:', this.lastActivity);
      if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'all':
            data.key2 = 'all';
            data.value2 = this.filterMonths;
            break;
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    callApiLead(selectedSource) {
      console.log(`Making API call with state: ${selectedSource}`);
      this.selectedSource = selectedSource;
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
        key8: 'prev_status_id',
        value8: this.previousPipeline,
      };

      if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'all':
            data.key2 = 'all';
            data.value2 = this.filterMonths;
            break;
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    callApiboard(selectedBoard) {
      console.log(`Making API call with state: ${selectedBoard}`);
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
        key8: 'prev_status_id',
        value8: this.previousPipeline,
      };
      if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'all':
            data.key2 = 'all';
            data.value2 = this.filterMonths;
            break;
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    onDateChange(value) {
      console.log('My Date:', value);
      this.scheduledAt = value;
      this.$store.dispatch('pipelines/create', { value });
    },
    filterbyinput() {
      const validSearch = /[a-zA-Z0-9]/.test(this.searchQuery);
      if (this.searchQuery && validSearch) {
        if (this.hasActiveBoardFilter) {
          this.applySearchInSavedBoardFilter(this.searchQuery);
          return;
        }
        let data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
          key8: 'prev_status_id',
        value8: this.previousPipeline,
        };

        if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
        // Normalize filterMonths value (e.g., replacing spaces with underscores)
        const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

        if (normalizedFilter) {
          switch (normalizedFilter) {
            case 'all':
              data.key2 = 'all';
              data.value2 = this.filterMonths;
              break;
            case 'last_week':
              data.key2 = 'last_week';
              data.value2 = this.filterMonths;
              break;
            case 'last_month':
              data.key2 = 'last_month';
              data.value2 = this.filterMonths;
              break;
            case 'last_six_months':
              data.key2 = 'last_six_months';
              data.value2 = this.filterMonths;
              break;
            default:
              console.warn('Unknown filterMonths value:', this.filterMonths);
              break;
          }
        } else {
          data.key2 = 'start_date';
          data.value2 = this.scheduledAtFrom; // The start date filter
          data.key3 = 'end_date';
          data.value3 = this.scheduledAtTo; // The end date filter
        }
        this.$store.dispatch('pipelines/FilterContact', data);   
    }else {
        this.showAlert('Please enter a valid search term.');
      }
    },
    buildSavedBoardSearchFilter(searchTerm) {
      const term = (searchTerm || '').trim();
      if (!term) return null;

      let attributeKey = 'contact_name';
      if (term.includes('@')) {
        attributeKey = 'contact_email';
      } else if (/^[0-9+\-\s()]+$/.test(term)) {
        attributeKey = 'contact_phone';
      }

      return {
        attribute_key: attributeKey,
        filter_operator: 'contains',
        values: [term],
        attribute_model: 'standard',
        custom_attribute_type: '',
        statusValues: [],
        query_operator: 'and',
      };
    },
    applySearchInSavedBoardFilter(searchTerm) {
      const activeQuery = this.activeBoardFilter?.query;
      if (!activeQuery) return;

      const baseFilters = Array.isArray(activeQuery.payload)
        ? activeQuery.payload.map(filter => ({ ...filter }))
        : [];
      const searchFilter = this.buildSavedBoardSearchFilter(searchTerm);

      if (searchFilter) {
        if (baseFilters.length > 0) {
          // Force search to be an additional AND group over the saved filter expression.
          baseFilters[baseFilters.length - 1] = {
            ...baseFilters[baseFilters.length - 1],
            query_operator: 'and',
          };
        }
        baseFilters.push(searchFilter);
      }

      this.fetchFilteredContacts({
        ...activeQuery,
        payload: baseFilters,
      });
    },
    async getallstate() {
      const data = await this.$store.dispatch('pipelines/getstate');
      console.log('Response', data);
    },
    onRangeChange(selectedId) {
      this.selectedRange = selectedId;
      if (this.selectedRange !== 'custom') {
        this.setScheduledDate(this.selectedRange);
        this.showCustomDate = false;
      } else {
        // Open modal for custom date selection
        this.showCustomDate = true;
      }
    },
    setScheduledDate(monthsBefore) {
      console.log('Months Before', monthsBefore);
      // const date = new Date();
      // date.setMonth(date.getMonth() - parseInt(monthsBefore, 10)); // Calculate date months before
      // this.scheduledAt = date.toISOString().slice(0, 10); // Set the formatted date
      if (monthsBefore == 'all') {
        this.filterMonths = 'all';
        const data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key2: 'all',
          value2: this.filterMonths,
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
          key8: 'prev_status_id',
        value8: this.previousPipeline,
        };
        if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
        this.$store.dispatch('pipelines/FilterContact', data);
      }
      if (monthsBefore == 'last week') {
        this.filterMonths = 'last week';
        const data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key2: 'last_week',
          value2: this.filterMonths,
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
          key8: 'prev_status_id',
        value8: this.previousPipeline,
        };
        if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
        this.$store.dispatch('pipelines/FilterContact', data);
      }
      if (monthsBefore == 'last month') {
        this.filterMonths = 'last month';
        const data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key2: 'last_month',
          value2: this.filterMonths,
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
          key8: 'prev_status_id',
        value8: this.previousPipeline,
        };
        if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
        this.$store.dispatch('pipelines/FilterContact', data);
      }
      if (monthsBefore == 'last six months') {
        this.filterMonths = 'last six months';
        const data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key2: 'last_six_months',
          value2: this.filterMonths,
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
          key8: 'prev_status_id',
        value8: this.previousPipeline,
        };
        if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
        this.$store.dispatch('pipelines/FilterContact', data);
      }
    },
    toggleCustomDate() {
      // this.showCustomDate = false; // Toggle modal visibility
      this.showCustomDate = !this.showCustomDate;
    },
    hideMorestate() {
      this.showMoreState = false;
    },
    hideMoreboard() {
      this.showMoreBoard = false;
    },
   onDateUpdate({ scheduledAtFrom, scheduledAtTo }) {
        // Combine date and time into single datetime strings
        const formatDateTime = (dt) => {
          if (!dt || !dt.date) return '';
          return dt.time ? `${dt.date} ${dt.time}` : dt.date;
        };

        const formattedFrom = formatDateTime(scheduledAtFrom);
        const formattedTo = formatDateTime(scheduledAtTo);

        this.scheduledAtFrom = formattedFrom;
        this.scheduledAtTo = formattedTo;

      // Prepare the data object with the formatted dates and filters
      const data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key2: 'start_date',
        value2: this.scheduledAtFrom, // The formatted start date
        key3: 'end_date',
        value3: this.scheduledAtTo, // The formatted end date
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
        key8: 'prev_status_id',
        value8: this.previousPipeline,
      };
      if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
      console.log('Date with filters:', data); // Log the final data object

        this.$store.dispatch('pipelines/FilterContact', data);
      },
    // formatDate(date) {
    //   // Split the date into year, month, and day
    //   const [year, month, day] = date.split('-');

    //   // Return the date in "DD-MM-YYYY" format
    //   return `${day}-${month}-${year}`;
    // },
    formatDate(date) {
      // Check if the date is valid and properly formatted
      if (!date || typeof date !== 'string' || !date.includes('-')) {
        console.error('Invalid date provided:', date);
        return 'Invalid date';
      }

      // Split the date into year, month, and day
      const [year, month, day] = date.split('-');

      // Return in the desired format "DD-MM-YYYY"
      return `${day}-${month}-${year}`;
    },

    checkMove(e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    softReloadPage() {
      this.$router.go(0);
    },
    openAssignee() {
      this.showAssignee = !this.showAssignee;
    },
    toggleAssignee({ id, assignee }) {
      console.log('Assignee id', id, assignee);
      this.currentAssigneedata = assignee;
      this.currentAssignee = id;
      this.showAssignee = false;
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
        key8: 'prev_status_id',
        value8: this.previousPipeline,
      };
      if (this.lastActivity) {
        switch (this.lastActivity) {
          case 2:
            data.key7 = 'last_activity';
            data.value7 = 'user';
            break;
          case 3:
            data.key7 = 'last_activity';
            data.value7 = 'agent';
            break;
            case 1: // Handle case for "All" selection
            data.key7 = 'last_activity';
            data.value7 = '';
            break;
          default:
            console.warn('Unknown lastActivity selection:', this.lastActivity);
            break;
        }
      }
      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    hideAssignee() {
      this.showAssignee = false;
    },
    toggleDropdown(dropdownName) {
      bus.$emit('toggle-pipeline-dropdown');
      this.showAssignee = false;
      this.openDropdown =
        this.openDropdown === dropdownName ? null : dropdownName;
    },
    backUrl() {
      if (this.hasActiveBoardFilter) {
        const boardId =
          this.currentBoardId || this.board_id || this.$route.params.board_id;
        
        // Clear the applied filters and appliedFilter state before going back
        this.$store.dispatch('pipelines/clearBoardFilters', {
          boardId: boardId,
        });
        this.appliedFilter = [];
        
        this.$router.push({
          name: 'pipeline_boards',
          params: { board_id: String(boardId) },
        });
        return;
      }
      this.$router.push({ name: 'settings_account_reports' });
    },
    closeAlldraggable() {
      this.showAssignee = false;
      this.openDropdown = null;
    },
    updateLeadCount() {
      setTimeout(() => {
        this.totalLeadCount = this.$refs.newPipeline.totalContactsCount;
        this.setPipelineScrollContainer();
      },200);
    },
    setPipelineScrollContainer() {
      this.$nextTick(() => {
        const container = this.$refs.pipelineContainer;
        if (container !== this.pipelineScrollContainer) {
          this.pipelineScrollContainer = container || null;
        }
      });
    },
    boardName() {
      const boardId = this.selectedBoard || this.board_id || this.$route.params.board_id;
      if (!boardId) {
        return this.$t('SIDEBAR.PIPELINES');
      }
      const board = this.boards.find(b => b.id === parseInt(boardId));
      return board ? board.name : 'Default Board';
    },
    clearActiveSavedBoardFilter() {
      const boardId = this.currentBoardId || this.selectedBoard || this.board_id || this.$route.params.board_id;
      this.$router.push({
        name: 'pipeline_boards',
        params: { board_id: String(boardId) },
      });
    },
    openReminderModal() {
      this.showReminderModal = true;
    },
    closeReminderModal() {
      this.showReminderModal = false;
    },
    refreshBoardAfterReminder(contactId) {
      if (contactId) {
        this.$store.dispatch('pipelines/clearContactReminder', contactId);
      }
      this.$store.dispatch('pipelines/fetchReminders', this.accountId);
    },
    // Board Filter Methods
    async onToggleAdvanceFiltersModal() {
      if (this.hasActiveBoardFilter) {
        await this.initializeBoardFilterToModal(this.activeBoardFilter);
      } else {
        this.appliedFilter = [...(this.currentBoardAppliedFilters || [])];
      }
      this.showAdvancedFilters = true;
    },
    closeAdvanceFiltersModal() {
      this.showAdvancedFilters = false;
      this.appliedFilter = [];
    },
    onApplyFilter(payload) {
      const boardId = Number(
        this.selectedBoard || this.board_id || this.$route.params.board_id
      );
      const normalizedBoardId = Number.isNaN(boardId) ? null : boardId;
      this.boardFiltersQuery = {
        ...filterQueryGenerator(payload.filters),
        board_id: normalizedBoardId,
      };
      // Store filters in Vuex
      this.$store.dispatch('pipelines/setBoardFilters', {
        boardId: normalizedBoardId,
        filters: payload.filters,
      });
      this.appliedFilter = [...(payload.filters || [])];
      // Apply filters to board view - you'll need to implement this API call
      this.fetchFilteredContacts(payload.filters);
      this.showAdvancedFilters = false;
    },
    async onUpdateBoardFilter(payload, filterName) {
      const boardId = Number(
        this.selectedBoard || this.board_id || this.$route.params.board_id
      );
      const payloadData = {
        ...this.activeBoardFilter,
        name: filterName,
        query: {
          ...filterQueryGenerator(payload),
          board_id: Number.isNaN(boardId) ? null : boardId,
        },
      };
      await this.$store.dispatch('customViews/update', payloadData);
      this.fetchFilteredContacts(payloadData.query);
      this.closeAdvanceFiltersModal();
    },
    clearFilters() {
      this.$store.dispatch('pipelines/clearBoardFilters', {
        boardId: this.currentBoardId,
      });
      this.appliedFilter = [];
      // Refresh board data without filters
      this.$store.dispatch('pipelines/getStatus', {
        board_id: this.selectedBoard || this.$route.params.board_id,
      });
    },
    syncBoardScopedFilters(boardIdValue) {
      const boardId = Number(boardIdValue);
      if (Number.isNaN(boardId)) return;

      const storeScopedFilters = this.getAppliedBoardFiltersByBoard
        ? this.getAppliedBoardFiltersByBoard(boardId) || []
        : [];
      const scopedFilters = storeScopedFilters;

      this.$store.dispatch('pipelines/setBoardFilters', scopedFilters);
      this.appliedFilter = [...scopedFilters];

      if (scopedFilters.length > 0) {
        this.fetchFilteredContacts(scopedFilters);
      } else {
        this.$store.dispatch('pipelines/getStatus', {
          board_id: boardId,
        });
      }
    },
    onClickOpenAddBoardFiltersModal() {
      this.showAddBoardFiltersModal = true;
    },
    onCloseAddBoardFiltersModal() {
      this.showAddBoardFiltersModal = false;
    },
    onClickOpenDeleteBoardFiltersModal() {
      this.showDeleteBoardFiltersModal = true;
    },
    handleBoardFilterDropdown(selectedId) {
      if (!selectedId) {
        this.$router.push({
          name: 'pipeline_boards',
          params: {
            board_id: String(this.currentBoardId),
          },
        });
        return;
      }
      this.$router.push({
        name: 'pipeline_custom_view',
        params: {
          board_id: String(this.currentBoardId),
          id: String(selectedId),
        },
      });
    },
    onCloseDeleteBoardFiltersModal() {
      this.showDeleteBoardFiltersModal = false;
    },
    async initializeBoardFilterToModal(activeBoardFilter) {
      const query = activeBoardFilter?.query?.payload;
      if (!Array.isArray(query)) return;

      await Promise.all([
        this.$store.dispatch('pipelines/getState'),
        this.$store.dispatch('pipelines/getBoards'),
        this.$store.dispatch('inboxes/get'),
      ]);

      const boards = this.$store.getters['pipelines/getAllBoards'] || [];
      const states = this.$store.getters['pipelines/getAllStatus'] || [];
      const inboxes = this.inboxes || [];
      const labels = (this.labels || []).map(label => ({
        id: label.id,
        name: label.title,
      }));
      const agents = this.assigneedata.filter(assignee => assignee.id !== '');
      const lastActivityOptions = [
        { id: 'user', name: 'Last Activity User' },
        { id: 'agent', name: 'Last Activity Agent' },
      ];
      const statuses = boards.flatMap(board =>
        (board.statuses_attributes || []).map(status => ({
          id: status.id,
          name: status.name,
        }))
      );

      const toArray = value =>
        Array.isArray(value)
          ? value
          : value === undefined || value === null || value === ''
          ? []
          : [value];

      const findOption = (options, rawValue) => {
        const option = (options || []).find(item => {
          const optionId = item?.id;
          return (
            optionId === rawValue ||
            String(optionId) === String(rawValue) ||
            Number(optionId) === Number(rawValue)
          );
        });
        if (!option) return { id: rawValue, name: rawValue };
        return {
          id: option.id,
          name: option.name || option.title || option.id,
        };
      };

      const mapMultiSelectValues = (attributeKey, rawValues) => {
        const valuesArray = toArray(rawValues);
        const optionMap = {
          state: states,
          source_of_lead: inboxes,
          status_id: statuses,
          board_id: boards,
          assignee_id: agents,
          last_activity_by: lastActivityOptions,
          labels_id: labels,
        };
        const options = optionMap[attributeKey];
        if (!options) return null;
        return valuesArray.map(value => findOption(options, value));
      };

      const params = {
        agents,
        labels,
        boards,
        inboxes,
        filterTypes: boardFilterTypes,
        allCustomAttributes: [],
      };

      this.appliedFilter = query.map(filter => {
        let values = filter.values;
        const mappedMultiSelectValues = mapMultiSelectValues(
          filter.attribute_key,
          filter.values
        );

        if (mappedMultiSelectValues) {
          values = mappedMultiSelectValues;
        } else if (Array.isArray(filter.values)) {
          values = generateValuesForEditCustomViews(filter, params);
        }

        return {
          attribute_key: filter.attribute_key,
          attribute_model: filter.attribute_model,
          filter_operator: filter.filter_operator,
          values,
          query_operator: filter.query_operator,
          custom_attribute_type: filter.custom_attribute_type,
          statusValues: Array.isArray(filter.statusValues)
            ? filter.statusValues.map(value => findOption(statuses, value))
            : filter.statusValues || null,
        };
      });
    },
    fetchFilteredContacts(filters) {
      const queryPayload =
        filters && !Array.isArray(filters) && Array.isArray(filters.payload)
          ? filters
          : filterQueryGenerator(filters);
      const boardId = this.selectedBoard || this.board_id || this.$route.params.board_id;
      
      // Use the new filter endpoint
      this.$store.dispatch('pipelines/filterStatus', {
        board_id: boardId,
        filters: queryPayload,
      });
    },
    openLastSavedItemInBoardFilter() {
      const boardFilterViews = this.boardFilters.filter(view => view.filter_type === 'board');
      if (boardFilterViews.length > 0) {
        const lastItemOfBoardFilter = boardFilterViews[boardFilterViews.length - 1];
        const lastItemId = lastItemOfBoardFilter.id;
        const boardId =
          lastItemOfBoardFilter?.query?.board_id ||
          this.selectedBoard ||
          this.board_id ||
          this.$route.params.board_id;
        
        // Clear manually applied filters for this board since they're now saved as a custom view
        this.$store.dispatch('pipelines/clearBoardFilters', {
          boardId: boardId,
        });
        this.appliedFilter = [];
        
        this.$router.push({
          name: 'pipeline_custom_view',
          params: {
            board_id: String(boardId),
            id: lastItemId,
          },
        });
      }
    },
    openLastItemAfterDeleteInBoardFilter() {
      const boardFilterViews = this.boardFilters.filter(view => view.filter_type === 'board');
      if (boardFilterViews.length > 0) {
        this.openLastSavedItemInBoardFilter();
      } else {
        const boardId = this.selectedBoard || this.$route.params.board_id;
        this.$router.push({
          name: 'pipeline_boards',
          params: { board_id: boardId },
        });
        // Refresh board data
        this.$store.dispatch('pipelines/getStatus', { board_id: boardId });
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
.no-padding {
  padding: 0px !important;
}
.w-100 {
  width: 100%;
}
.w-40 {
  width: 40%;
}
.w-60 {
  width: 60%;
}
.pipeline {
  align-items: center;
}
.pipeline-filter-date {
  margin: 0px;
}
.filter-input >>> input {
  margin: unset;
}
.pipeline-dropdown {
  margin: 0px;
}

.filter-box {
  gap: 10px;
  align-items: center;
}
.input-search {
  flex: 0 1 520px;
  max-width: 520px;
  width: 100%;
}
.pipeline-container {
  overflow-x: auto; /* Enable horizontal scrolling */
  background: #c9c7c729;
  height: 100%;
}
body.dark .pipeline-container {
  background-color: hsl(198 6.6% 15.8% / 1);
  overflow-x: auto;
  height: 93%;
}
.search-icon {
  margin-right: 8px; /* Adjust as needed */
  position: absolute;
  color: lightgray;
  right: 9px;
  top: 10px;
  z-index: 99;
}
.calendar-icon {
  margin-right: 8px; /* Adjust as needed */
  position: absolute;
  right: 22px;
  top: 10px;
  z-index: 99;
}
.new-color {
  color: #989898;
  font-size: 14px;
}
.board-filter-top-dropdown {
  width: 150px;
  min-width: 135px;
}
.saved-filter-chip {
  display: inline-flex;
  align-items: center;
  max-width: 16rem;
  margin-left: 0.5rem;
  padding: 0.50rem 0.35rem;
  border-radius: 0.35rem;
  background: #eaf2ff;
  color: #40518a;
}
.saved-filter-chip-text {
  max-width: 13rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.875rem;
}
.saved-filter-chip-close {
  margin-left: 0.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  cursor: pointer;
}
.pipeline-filter-select {
  margin: unset;
  padding-left: 27px;
}
.grey-color {
  color: lightgrey;
}
.search-wrap {
  .contact-search {
    border-radius:9px;
    font-size: 14px;
    padding: 21px 5px;
    border: 1px solid #ccc;
    @apply w-full h-[2.375rem] m-0;
  }

  .button {
    transition: transform 100ms linear;
    @apply ml-2 h-8 right-1 absolute py-0 px-2 opacity-0 -translate-x-px invisible;
  }

  .button.show {
    @apply opacity-100 translate-x-0 visible;
  }
}
.assignee-img {
  position: absolute;
  display: flex;
  top: 10px;
  left: 16%;
}
.assignee-list {
  position: absolute;
  z-index: 9;
}
.assignee-user {
  position: sticky;
}
.empty-assignee {
  width: 251px;
  height: 65px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: large;
}
.date {
  position: relative;
  bottom: 10px;
}
.calendar {
  position: relative;
  top: 30px;
  padding-left: 4px;
  display: ruby;
}
.search-icon-data {
  position: relative;
  right: 26px;
  background-color: #ffffff;
}
.grey-color {
  color: #6b6b6b;
}

.reminder-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 43px;
  height: 43px;
  border-radius: 8px;
  // background: #f3f4f6;
  transition: all 0.2s ease;
  border: 1px solid #ccc;
  
  &:hover {
    background: #e5e7eb;
    transform: translateY(-1px);
  }
}

.reminder-icon {
  color: #ccc;
  transition: color 0.2s ease;
}

.reminder-icon-wrapper:hover .reminder-icon {
  color: #4b5563;
}

body.dark .reminder-icon-wrapper {
  background: #374151;
  
  &:hover {
    background: #4b5563;
  }
}

body.dark .reminder-icon {
  color: #9ca3af;
}

body.dark .reminder-icon-wrapper:hover .reminder-icon {
  color: #d1d5db;
}

.icon-with-badge {
  position: relative;
  display: inline-block;
}

.dual-badge {
  position: absolute;
  right: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  right: 0;
  left: 0;
}

.notification-badge {
  font-size: 10px;
  padding: 2px 6px;
  color: white;
  font-weight: bold;
  min-width: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 0 0 1px white;
}

.green-badge {
  background-color: #28a745;
}

.red-badge {
  background-color: #dc3545;
}



</style>
